import { ImageContainer, Modal } from "@r360/library";
import classNames from "classnames";
import React, { useState } from "react";
import useAppSelector from "../../hooks/useAppSelector";
import { TImage, TThumbnail } from "../../store/types";
import ProductImagesGallery from "../ProductImagesGallery/ProductImagesGallery";

type TProductImage = {
    mainImage: TImage | TThumbnail | undefined;
    images?: TImage[];
    showMoreImages: boolean;
    showImageDescriptions: boolean;
    fallbackImage?: string;
    lang: string;
    imageRef: React.RefObject<HTMLDivElement>;
    cardHeightIsLargerThanImage: boolean;
    externalProductAccessibility?: string;
};

export const ProductCardImage = ({
    mainImage,
    images,
    showMoreImages,
    showImageDescriptions,
    fallbackImage,
    lang,
    imageRef,
    cardHeightIsLargerThanImage,
    externalProductAccessibility,
}: TProductImage) => {
    const { isIframe, isDesktop, isMobile, isTablet, iframeOffsetTop } = useAppSelector(state => state.window);
    const [showGalleryModal, setShowGalleryModal] = useState(false);

    return (
        <>
            <div
                className={classNames("r360-product-card__img-wrapper", {
                    "r360-product-card__img-wrapper--no-bottom-radius": cardHeightIsLargerThanImage,
                })}
            >
                <div ref={imageRef} className="r360-product-card__img">
                    <ImageContainer
                        imgUrl={mainImage?.url}
                        actions={showMoreImages ? ["see-more"] : []}
                        actionsConfig={{ position: "bottom-left" }}
                        onActionClick={action => {
                            if (action === "see-more") {
                                setShowGalleryModal(true);
                            }
                        }}
                        noBorderRadius
                        fallbackUrl={fallbackImage}
                        altText={
                            mainImage?.translations?.[lang]?.accessibility
                                ? mainImage.translations[lang].accessibility
                                : externalProductAccessibility || ""
                        }
                    />
                </div>
            </div>
            {images && showMoreImages && (
                <Modal
                    open={showGalleryModal}
                    size="lg"
                    onClose={() => setShowGalleryModal(false)}
                    {...(isIframe && isDesktop && { fromTop: 120 + iframeOffsetTop + "px" })}
                    {...(isIframe &&
                        (isMobile || isTablet) && {
                            fromTop: 80 + iframeOffsetTop + "px",
                        })}
                    className="r360-product-card__gallery-modal"
                >
                    <ProductImagesGallery
                        images={images.map(image => ({
                            thumbnail: image.url,
                            original: image.url,
                            translations: image?.translations,
                        }))}
                        showImageDescriptions={showImageDescriptions}
                    />
                </Modal>
            )}
        </>
    );
};
